module.exports = __webpack_public_path__ + "static/media/FamilyFriends.32cf6bb4.png";